export const GEO_TYPE_PARAM = "geo_type";
export const STATE_PARAM = "state";
export const NATIONAL_PARAM = "National";
export const COMPARISON_STATE_PARAM = "state_comparison";
export const VIEW_TYPE_PARAM = "view_type";
export const GEO_VALUE_PARAM = "geo";
export const GEO_VALUE_STATEWIDE = "statewide";
export const DEMO_FILTERS_PARAM = "demo_filters";
